export const iconFontAwesomeEducationSchoolCircleXmark = (
	<i className="fa-solid fa-school-circle-xmark"></i>
);
